import { render, staticRenderFns } from "./RefClaimShow.vue?vue&type=template&id=32340f9d&"
import script from "./RefClaimShow.vue?vue&type=script&lang=js&"
export * from "./RefClaimShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports